import { render } from "./SelectMasterDataMapping.vue?vue&type=template&id=fb7ce71a&ts=true"
import script from "./SelectMasterDataMapping.vue?vue&type=script&lang=ts"
export * from "./SelectMasterDataMapping.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QIcon});
